import React from 'react'
import { Button, Dialog, InputAdornment, TextField } from '@material-ui/core'
import { FaCalendarAlt } from 'react-icons/fa'
import { MdDelete } from 'react-icons/md'

export default function CustomPeriodButton({ onApply, period }) {
    const [open, setOpen] = React.useState(false)

    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [startDate, setStartDate] = React.useState('')
    const [endDate, setEndDate] = React.useState('')

    React.useEffect(() => {
        if(period !== 'personalized') {
            setStartDate('')
            setEndDate('')
        }
    }, [period])

    const handleApply = () => {
        if (!startDate || !endDate) return

        onApply?.({
            start_date: startDate,
            end_date: endDate
        })

        setOpen(false)
    }

    const handleClear = () => {
        setStartDate('')
        setEndDate('')
        setOpen(false)
    }

    return (
        <>
            <Button
                className={"btn-icon-center bs-bg-invert bs-color-b " + (startDate !== '' && 'btn-checked')}
                variant="contained"
                color="primary"
                onClick={() => {
                    setOpen(true)
                }}
                startIcon={<FaCalendarAlt />}
            >
            </Button>


            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="xs"
                className="center"
            >
                <div className="card card-body bs-bg">
                    <label className="fw-bold label-custom bs-color-b mb-0 d-flex align-items-center"><FaCalendarAlt className="me-2" /> Período personalizado</label>
                    
                    <hr className="hr-muted" />

                    <div className="mb-3 mt-2">
                        <label className="label-custom bs-color-b">Data inicial</label>
                        
                        <div className="date">
                            <label className="label-date bs-color-b">
                                {(startDate) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(startDate))}&nbsp;&nbsp;&nbsp;
                                {(startDate) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(startDate))}    
                            </label>
                            <TextField
                                id="datetime-local"
                                type="datetime-local"
                                defaultValue={startDate ? startDate : dateInit}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={e => {
                                    if(e.target.value) {
                                        setStartDate(e.target.value)
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <>
                                        {startDate &&
                                            <InputAdornment className="pointer bs-color" position="end" onClick={() => setStartDate('')}>
                                                <MdDelete color="#aaa" size={25} />
                                            </InputAdornment>
                                        }
                                        </>
                                    )
                                }}
                            />
                        </div>
                    </div>

                    <div className="mb-3">
                        <label className="label-custom bs-color-b">Data final</label>
                        
                        <div className="date">
                            <label className="label-date bs-color-b">
                                {(endDate) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(endDate))}&nbsp;&nbsp;&nbsp;
                                {(endDate) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(endDate))}    
                            </label>
                            <TextField
                                id="datetime-local"
                                type="datetime-local"
                                defaultValue={endDate ? endDate : dateEnd}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                onBlur={e => {
                                    if(e.target.value) {
                                        setEndDate(e.target.value)
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <>
                                        {endDate &&
                                            <InputAdornment className="pointer bs-color" position="end" onClick={() => setEndDate('')}>
                                                <MdDelete color="#aaa" size={25} />
                                            </InputAdornment>
                                        }
                                        </>
                                    )
                                }}
                            />
                        </div>
                    </div>

                    
                    <div className="d-flex justify-content-end gap-3 mt-3">
                        <Button
                            className={"ps-3 pe-3 bs-bg-invert bs-color-b fw-bold"}
                            variant="contained" 
                            color="primary"
                            onClick={handleClear}
                        >
                            Limpar
                        </Button>

                        <Button
                            variant="contained" 
                            color="primary"
                            className="fw-bold btn-theme"
                            onClick={handleApply}
                            disabled={!startDate || !endDate}
                        >
                            Aplicar
                        </Button>
                    </div>
                </div>
            </Dialog>
        </>
    )
}